document.addEventListener('DOMContentLoaded', function () {
  const mapElement   = document.querySelector('.map');
  const listElement  = document.querySelector('.map-list');
  const categorySel  = document.querySelector('.map-filter-category');
  const businessSel  = document.querySelector('.map-filter-business');
  const modeButtons  = document.querySelectorAll('.mode-btn');
  const listBlock  = document.querySelectorAll('.map-list-container__left');
  const mapBlock  = document.querySelectorAll('.map-list-container__right');
  if (!mapElement) return;

  const PAGE_SIZE = 7;
  let currentPage = 1;
  let viewMode = 'both'; 

  const LOCATIONS = [
    { id:'p1',  category:'Agricultura y floristería',   name:'Agrocousas',      coords:[42.054621,-6.634209], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/agrocousas.webp',      link:'/ficha' },
    { id:'p2',  category:'Restauración', name:'Casa Sabor',     coords:[42.055200,-6.632800], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/placeholder.png',   link:'#' },
    { id:'p3',  category:'Farmacia',     name:'FarmaPlus',      coords:[42.053900,-6.635100], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/placeholder.png',     link:'#' },
    { id:'p4',  category:'Tecnología',   name:'ByteWorks',      coords:[42.054100,-6.636000], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/placeholder.png',     link:'#' },
    { id:'p5',  category:'Agricultura y floristería',   name:'JardínArte',     coords:[42.055700,-6.633500], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/placeholder.png',       link:'#' },
    { id:'p6',  category:'Restauración', name:'El Fogón',       coords:[42.056100,-6.634900], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/placeholder.png',        link:'#' },
    { id:'p7',  category:'Farmacia',     name:'SaludTotal',     coords:[42.052900,-6.633900], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/placeholder.png',    link:'#' },
    { id:'p8',  category:'Tecnología',   name:'TecnoHub',       coords:[42.053500,-6.632200], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/placeholder.png',          link:'#' },
    { id:'p9',  category:'Agricultura y floristería',   name:'Green&Go',       coords:[42.054900,-6.631800], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/placeholder.png',       link:'#' },
    { id:'p10', category:'Restauración', name:'Mar y Tierra',   coords:[42.055900,-6.635900], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/placeholder.png',     link:'#' },
    { id:'p11', category:'Farmacia',     name:'Botica Central', coords:[42.056300,-6.633000], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/placeholder.png',   link:'#' },
    { id:'p12', category:'Tecnología',   name:'CodePoint',      coords:[42.052700,-6.635700], short:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.', image:'assets/img/placeholder.png',       link:'#' }
  ];

  let selectedCategory = '';
  let selectedBusiness = '';

  let pendingOpenId = null;
  let pendingOpenCoords = null;

  const map = L.map(mapElement, {
    dragging: false,
    scrollWheelZoom: false,
    touchZoom: false,
    doubleClickZoom: false,
    boxZoom: false,
    keyboard: false,
    tap: false
  }).setView(LOCATIONS[0].coords, 16);

  L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
    attribution: '© OpenStreetMap contributors'
  }).addTo(map);

  const customIcon = L.divIcon({
    className: 'map-icon',
    iconSize: [24, 50],
    iconAnchor: [12, 50],
    popupAnchor: [0, -50]
  });

  const markersById = new Map();
  const markersGroup = L.featureGroup().addTo(map);

  LOCATIONS.forEach(loc => {
    const popupHtml = `
      <div class="map-content" style="max-width:260px">
        <img src="${loc.image}" alt="${loc.name}" style="width:100%;height:auto;border-radius:6px;margin-bottom:6px;">
        <span class="text-size--xs">${loc.name}</span><br>
        <span class="u-mt-3xs u-mb-3xs">${loc.category}</span><br>
        <span style="opacity:.9">${loc.short || ''}</span><br>
        <a href="${loc.link}" rel="noopener" style="display:inline-block;margin-top:6px;">Más información</a>
      </div>
    `;
    const marker = L.marker(loc.coords, { icon: customIcon }).bindPopup(popupHtml);
    marker.on('click', () => handleMarkerClick(loc));
    markersById.set(loc.id, marker);
  });

  fitToLocations(LOCATIONS);

  const pagerElement = document.createElement('nav');
  pagerElement.className = 'map-pager';
  if (listElement) listElement.insertAdjacentElement('afterend', pagerElement);

  function getTotalPages(items) { return Math.max(1, Math.ceil(items.length / PAGE_SIZE)); }
  function getSliceForPage(items, page) { const start = (page - 1) * PAGE_SIZE; return items.slice(start, start + PAGE_SIZE); }

  function renderPager(totalPages) {
    if (!pagerElement) return;
    if (viewMode !== 'list' && viewMode !== 'both') { pagerElement.innerHTML = ''; return; }
    if (totalPages <= 1) { pagerElement.innerHTML = ''; return; }

    let html = '';
    const prevDisabled = currentPage <= 1 ? 'disabled' : '';
    const nextDisabled = currentPage >= totalPages ? 'disabled' : '';

    html += `<button type="button" data-nav="prev" ${prevDisabled}>Anterior</button>`;
    const pages = buildPageList(totalPages, currentPage);
    pages.forEach(p => {
      if (p === '…') html += `<span>…</span>`;
      else {
        const active = p === currentPage ? 'is-active' : '';
        html += `<button type="button" data-page="${p}" class="${active}">${p}</button>`;
      }
    });
    html += `<button type="button" data-nav="next" ${nextDisabled}>Siguiente</button>`;
    pagerElement.innerHTML = html;

    pagerElement.querySelectorAll('button[data-page]').forEach(btn => {
      btn.addEventListener('click', () => { currentPage = parseInt(btn.dataset.page, 10); renderAll(); });
    });
    const prevBtn = pagerElement.querySelector('button[data-nav="prev"]');
    const nextBtn = pagerElement.querySelector('button[data-nav="next"]');
    if (prevBtn) prevBtn.addEventListener('click', () => { currentPage = Math.max(1, currentPage - 1); renderAll(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { currentPage = Math.min(totalPages, currentPage + 1); renderAll(); });
  }

  function buildPageList(total, current) {
    const pages = [];
    const show = 7;
    if (total <= show) { for (let i = 1; i <= total; i++) pages.push(i); return pages; }
    const first = 1, last = total, windowSize = 2;
    pages.push(first);
    const start = Math.max(first + 1, current - windowSize);
    const end   = Math.min(last - 1,  current + windowSize);
    if (start > first + 1) pages.push('…');
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < last - 1) pages.push('…');
    pages.push(last);
    return pages;
  }

  function renderList(items) {
    if (!listElement) return;
    if (viewMode !== 'list' && viewMode !== 'both') { listElement.innerHTML = ''; return; }

    listElement.innerHTML = '';
    const pageItems = getSliceForPage(items, currentPage);
    pageItems.forEach(loc => {
      const li = document.createElement('li');
      li.className = 'map-list-item';
      li.dataset.id = loc.id;
      li.innerHTML = `
        <img class="map-list-thumb" src="${loc.image}" alt="${loc.name}">
        <div class="map-list-item-content">
          <span class="title text-size--s">${loc.name}</span>
          <span>${loc.category}</span>
          <span class="desc">${loc.short || ''}</span>
          <div class="actions">
            <a class="js-open-link" href="${loc.link}" rel="noopener">Más información</a>
          </div>
        </div>
      `;
      li.addEventListener('click', () => openLocation(loc.id));
      li.querySelector('.js-open-link').addEventListener('click', (e) => e.stopPropagation());
      listElement.appendChild(li);
    });
  }

  function renderMarkers(items) {
    markersGroup.clearLayers();
    items.forEach(loc => {
      const marker = markersById.get(loc.id);
      if (marker) markersGroup.addLayer(marker);
    });
    if (viewMode === 'map' || viewMode === 'both') fitToLocations(items);
  }

  function fitToLocations(items) {
    if (!items.length) return;
    const latlngs = items.map(l => l.coords);
    const bounds = L.latLngBounds(latlngs);
    map.fitBounds(bounds, { padding: [20, 20] });
  }

  // ===== Filtros =====
  initCategorySelect();
  updateBusinessSelect();

  categorySel.addEventListener('change', () => {
    selectedCategory = categorySel.value;
    selectedBusiness = '';
    updateBusinessSelect();
    currentPage = 1;
    renderAll();
  });

  businessSel.addEventListener('change', () => {
    selectedBusiness = businessSel.value;
    currentPage = 1;
    renderAll();
  });

  function initCategorySelect() {
    const categories = Array.from(new Set(LOCATIONS.map(l => l.category))).sort();
    categorySel.innerHTML = `<option value="" selected disabled>Categoría</option>` +
      `<option value="Todas">Todas</option>` +
      categories.map(c => `<option value="${c}">${c}</option>`).join('');
    selectedCategory = '';
  }

  function updateBusinessSelect() {
    const source = (!selectedCategory || selectedCategory === 'Todas') ? LOCATIONS : LOCATIONS.filter(l => l.category === selectedCategory);
    const names = source.slice().sort((a,b) => a.name.localeCompare(b.name, 'es'));
    businessSel.innerHTML = `<option value="" selected disabled>Negocio</option>` +
      `<option value="Todos">Todos</option>` +
      names.map(l => `<option value="${l.id}">${l.name}</option>`).join('');
    selectedBusiness = '';
  }

  function getFilteredData() {
    let items = LOCATIONS;
    if (selectedCategory && selectedCategory !== 'Todas') items = items.filter(l => l.category === selectedCategory);
    if (selectedBusiness && selectedBusiness !== 'Todos') items = items.filter(l => l.id === selectedBusiness);
    return items;
  }

  function openLocation(id) {
    const filtered = getFilteredData();
    const loc = filtered.find(l => l.id === id) || LOCATIONS.find(l => l.id === id);
    const marker = markersById.get(id);
    if (!loc || !marker) return;

    jumpToPageForId(id, filtered);
    if (viewMode === 'list') {
      highlightListItem(id);
    } else {
      map.setView(loc.coords, Math.max(map.getZoom(), 16), { animate: true });
      marker.openPopup();
      highlightListItem(id);
    }
  }

  function highlightListItem(id) {
    if (!listElement) return;
    listElement.querySelectorAll('.map-list-item').forEach(el => el.classList.remove('is-active'));
    const active = listElement.querySelector(`.map-list-item[data-id="${id}"]`);
    if (active) active.classList.add('is-active');
  }

  function jumpToPageForId(id, items) {
    const idx = items.findIndex(l => l.id === id);
    if (idx === -1) return;
    const page = Math.floor(idx / PAGE_SIZE) + 1;
    if (page !== currentPage) {
      currentPage = page;
      renderAll();
    }
  }

  function handleMarkerClick(loc) {
    const filtered = getFilteredData();
    const idx = filtered.findIndex(l => l.id === loc.id);
    const targetPage = (idx === -1) ? 1 : Math.floor(idx / PAGE_SIZE) + 1;

    if (targetPage !== currentPage) {
      pendingOpenId = loc.id;
      pendingOpenCoords = loc.coords;
      currentPage = targetPage;
      renderAll();
    } else {
      focusAndOpen(loc.id, loc.coords);
    }
  }

  function focusAndOpen(id, coords) {
    const marker = markersById.get(id);
    if (!marker) return;
    if (viewMode !== 'list') {
      map.setView(coords, Math.max(map.getZoom(), 16), { animate: true });
      setTimeout(() => marker.openPopup(), 0);
    }
    highlightListItem(id);
  }

  const container = map.getContainer();
  container.style.touchAction = 'pan-y';

  function enableDrag() {
    if (!map.dragging.enabled()) {
      map.dragging.enable();
      container.style.touchAction = 'none';
    }
  }
  function disableDrag() {
    if (map.dragging.enabled()) {
      map.dragging.disable();
      container.style.touchAction = 'pan-y';
    }
  }
  if (window.PointerEvent) {
    container.addEventListener('pointerdown', enableDrag, { capture: true, passive: true });
    window.addEventListener('pointerup', disableDrag, { passive: true });
    window.addEventListener('pointercancel', disableDrag, { passive: true });
  } else {
    container.addEventListener('touchstart', enableDrag, { capture: true, passive: true });
    window.addEventListener('touchend', disableDrag, { passive: true });
    container.addEventListener('mousedown', enableDrag, { capture: true });
    window.addEventListener('mouseup', disableDrag);
  }
  map.on('dragend', disableDrag);

  modeButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      viewMode = btn.dataset.mode; 
      modeButtons.forEach(b => b.classList.toggle('is-active', b === btn));
      applyViewMode();
      renderAll();
    });
  });

  function applyViewMode() {
    const container = document.querySelector('.map-list-container');
    if (!container) return;

    container.classList.remove('view-map', 'view-list');

    if (viewMode === 'map') {
      container.classList.add('view-map');
      setTimeout(() => {
        map.invalidateSize();
        fitToLocations(getFilteredData());
      }, 0);
    } else if (viewMode === 'list') {
      container.classList.add('view-list');
    }
  }

  function renderAll() {
    const filtered = getFilteredData();
    const totalPages = getTotalPages(filtered);
    currentPage = Math.min(Math.max(1, currentPage), totalPages);

    renderList(filtered);
    renderPager(totalPages);
    renderMarkers(filtered);

    if (pendingOpenId) {
      const id = pendingOpenId;
      const coords = pendingOpenCoords;
      pendingOpenId = null;
      pendingOpenCoords = null;
      setTimeout(() => focusAndOpen(id, coords), 0);
    }
  }

  applyViewMode();
  renderAll();
});


// MOBILE

function activateMobileMapView() {
  if (window.innerWidth < 992) {
    // 1. Ocultar .btn-map-list
    document.querySelectorAll('.btn-map-list').forEach(el => {
      el.style.display = 'none';
    });

    // 2. Añadir clase is-active al botón .btn-map
    const btnMap = document.querySelector('.btn-map');
    if (btnMap) {
      btnMap.classList.add('is-active');
    }

    // 3. Añadir clase view-map a .map-list-container
    const mapListContainer = document.querySelector('.map-list-container');
    if (mapListContainer) {
      mapListContainer.classList.add('view-map');
    }
  }
}

// Ejecutar al cargar
document.addEventListener('DOMContentLoaded', activateMobileMapView);

// Opcional: volver a comprobar al redimensionar
window.addEventListener('resize', activateMobileMapView);
